import ApiCall from "./ApiCall";
import { decrypt } from "./Crypto";

const Handler = async ({ method, url, data = null, headers = {}, formdata = false, params = {}, silent = false }) => {
    try {
        // silent: a background call (e.g. saving the push token). If it comes back 401 it
        // must not throw the whole app to the "Unauthorized" screen.
        const response = await ApiCall({ url, method, data, headers, formdata, params, silent });

        if (headers["Content-Type"] === "application/zip") {
            return { success: true, data: { success: true, data: response } };
        }

        if (!response?.success) {
            return { success: false, data: response };
        }

        return {
            success: true,
            data: {
                code: response?.code,
                message: response?.message,
                success: response?.success,
                data: response?.data ? decrypt(response?.data)?.data : undefined,
            },
        };
    } catch (error) {
        return {
            success: false,
            data: error?.response?.data || { success: false, message: "Retry after sometime" },
        };
    }
};

export default Handler;
